import React, { BaseSyntheticEvent } from 'react'
import { IonButton } from '@ionic/react'
import './OfflineOnlineButton.component.css'
import { useOfflineStatus } from '../../utilities/isOnline.util'
export interface IOfflineOnlineButtonProps {
  label: string
  dataTestId: string
  disabled?: boolean
  onClick?: () => void
}

const OfflineOnlineButton: React.FC<IOfflineOnlineButtonProps> = (props: IOfflineOnlineButtonProps) => {
  const { label, dataTestId, disabled, onClick } = props
  const isOfflineStatus = useOfflineStatus()

  const doOnClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()

    if (onClick) {
      onClick()
    }
  }

  const isButtonDisabled = (): boolean => {
    if (isOfflineStatus) {
      return true
    }

    if (disabled) {
      return disabled
    }

    return false
  }

  return (
    <IonButton
      className='btn btn-primary upload-button'
      data-testid={dataTestId}
      onClick={doOnClick}
      disabled={isButtonDisabled()}>
      {label}
    </IonButton>
  )
}

export default OfflineOnlineButton
